import { Component } from '@angular/core';

@Component({
  selector: 'allas-como-cambiar-los-limpiaparabrisas',
  imports: [],
  template: `
    <main class="flex flex-col gap-2 mt-12 max-w-6xl mx-auto w-full">
      <!-- Desktop Version -->
      <section class="hidden xl:flex flex-col xl:flex-row my-6 xl:my-12">
        <div
          class="p-6 xl:p-6 flex flex-col items-center justify-center flex-auto xl:h-[400px]"
        >
          <article class="flex flex-col gap-2">
            <h2 class="text-2xl xl:text-5xl font-bold fs-condensed">
              ¿Cómo cambiar los <br />
              limpiaparabrisas?
            </h2>
            <p>
              Si prefieres hacerlo tú mismo, aquí tienes una <br />
              guía paso a paso. Recuerda que en Allas <br />
              Repuestos también lo hacemos por ti.
            </p>
          </article>
        </div>
        <div class="h-auto xl:h-[400px]">
          <img
            src="/images/services/cambio-limpiaparabrisas/limpiaparabrisas.webp"
            alt="cambiar limpiaparabrisas"
            class="h-full w-auto object-cover"
          />
        </div>
      </section>

      <!-- Mobile Version -->
      <section class="xl:hidden flex flex-col my-6">
        <div class="p-6 flex flex-col items-center justify-center">
          <article class="flex flex-col gap-2 text-center">
            <h2 class="text-4xl font-bold fs-condensed">
              ¿Cómo cambiar los limpiaparabrisas?
            </h2>
            <p class="text-sm">
              Si prefieres hacerlo tú mismo, aquí tienes una guía paso a paso.
              Recuerda que en Allas Repuestos también lo hacemos por ti.
            </p>
          </article>
        </div>
        <div class="h-auto">
          <img
            src="/images/services/cambio-limpiaparabrisas/limpiaparabrisas.webp"
            alt="cambiar limpiaparabrisas"
            class="h-full w-full object-cover"
          />
        </div>
      </section>
      <section class="grid grid-cols-1 xl:grid-cols-3 gap-6">
        @for (paso of pasos; track paso.step) {
        <article class="flex flex-col gap-2">
          <div class="relative">
            <img
              [src]="paso.img"
              [alt]="paso.step"
              class="w-full h-auto object-cover"
            />
            <span
              class="absolute top-0 right-0 mr-3 mt-3 text-white text-4xl font-bold fs-condensed -skew-x-6 rounded-full p-1"
              style="backdrop-filter: blur(8px); background: rgba(30,30,30,0.25);"
            >
              {{ paso.step }}
            </span>
          </div>
          <p
            class="font-light text-center mt-2 opacity-90"
            [innerHTML]="paso.htmlDescription"
          ></p>
        </article>
        }
      </section>
    </main>
  `,
})
export class ComoCambiarLosLimpiaparabrisas {
  pasos = [
    {
      step: 1,
      img: '/images/services/cambio-limpiaparabrisas/paso-1.webp',
      htmlDescription: `Levanta el brazo del <br> limpiaparabrisas: Levanta <br> cuidadosamente el brazo hasta que <br> quede perpendicular al parabrisas.`,
    },
    {
      step: 2,
      img: '/images/services/cambio-limpiaparabrisas/paso-2.webp',
      htmlDescription: `Baja con cuidado el brazo: <br> Baja el brazo para no lastimar el <br> cristal mientras trabajas.`,
    },
    {
      step: 3,
      img: '/images/services/cambio-limpiaparabrisas/paso-3.webp',
      htmlDescription: `Quita el seguro y retira el <br> limpiaparabrisas: Presiona el <br> seguro de plástico y desliza <br> hacia afuera.`,
    },
    {
      step: 4,
      img: '/images/services/cambio-limpiaparabrisas/paso-4.webp',
      htmlDescription: `Sube el brazo e inserta el nuevo <br> limpiaparabrisas: Alinea <br> correctamente y deliza hasta <br> escuchar el clic.`,
    },
    {
      step: 5,
      img: '/images/services/cambio-limpiaparabrisas/paso-5.webp',
      htmlDescription: `Quita el seguro y retira el <br> limpiaparabrisas: Retira <br> completamente el <br> limpiaparabrisas viejo.`,
    },
    {
      step: 6,
      img: '/images/services/cambio-limpiaparabrisas/paso-6.webp',
      htmlDescription: `Cierra el seguro de plástico: <br> Asegura el nuevo <br> limpiaparabrisas en su posición <br> final.`,
    },
  ];
}
